import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { IHotel, IHotelContact } from "../../../models/BaseModel";
import { Fetch } from "../../../shared/Fetch";
import { confirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { ContactForm } from "./ContactForm";

interface Iprops {
    open: boolean,
    hideDialog: () => void,
    hotel: IHotel,
    toast: any
}

export const ContactTable = (props: Iprops) => {
    const [tableData, setTableData] = useState({ data: [], loading: false } as { data: IHotelContact[], loading: boolean });
    const [modal, setModal] = useState<{ contact: IHotelContact, open: boolean }>({ contact: {}, open: false });

    useEffect(() => {
        if (props.hotel.id) loadTableData(props.hotel.id);
    }, [props.hotel.id]);

    const loadTableData = async (hotelId: number) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`HotelContact/${hotelId}`, "GET", null, null, props.toast);
        if (response) {
            const hotelContacts: IHotelContact[] = await response.json();
            setTableData({ data: hotelContacts, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const openNew = () => {
        setModal({ contact: { hotelId: props.hotel.id, isPrimary: false }, open: true });
    };

    const openEdit = (r: IHotelContact) => {
        setModal({ contact: { ...r }, open: true });
    };

    const onContactAddOrUpdateSuccess = () => {
        if (props.hotel.id) loadTableData(props.hotel.id);
        setModal({ contact: {}, open: false });
    }
    const onClose = () => {
        setModal({ contact: {}, open: false });
    }

    const Remove = async (rowData: IHotelContact) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`HotelContact/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Contact Deleted", life: 3000 });
            if (props.hotel.id) loadTableData(props.hotel.id);
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: IHotelContact) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.name}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }

    const actionBodyTemplate = (rowData: IHotelContact) => {
        return (
            <div className="actions">
                <Button icon="pi pi-pencil" className='p-button-success p-button-text p-0' onClick={() => openEdit(rowData)} />
                <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }}  ></Button>
            </div>
        );
    };

    const statusBody = (rowData: IHotelContact) => {
        return (
            <span>{rowData.isPrimary ? 'Yes' : 'No'}</span>
        );
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4"
            style={{
                background: "linear-gradient(90deg, #def7e3ff, #ecf4edff)",
                borderBottom: "2px solid #95e99c",
                borderRadius: "8px 8px 0 0",
                padding: "0.6rem 1rem",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)"
            }}>
            <div className="flex gap-4 w-full">
                <Button style={{ width: '80px', height: '30px' }} loading={tableData.loading} onClick={openNew} label="New" icon="pi pi-plus"
                    type="button"
                    className="p-button-sm p-button-rounded p-button-success mb-2"
                />
                <div className="w-full flex align-items-center justify-content-center">
                    <h5 style={{ margin: 0, color: "#00796b" }}>
                       Contacts : {props.hotel.name}
                    </h5>
                </div>
            </div>
            <div className="flex gap-4">

            </div>
        </div>
    );


    if (!props.open) return null;
    return (
        <div
            style={{
                backgroundColor: "#ffffff",
                border: "1px solid #a0d8a0",
                borderRadius: "12px",
                padding: "1rem",
                margin: "1rem 0",
                boxShadow: "0 4px 12px rgba(0, 128, 0, 0.1)"  // soft green shadow
            }}
        >
            {/* {modal.open ? <ContactForm onSuccess={onContactAddOrUpdateSuccess} onClose={onClose} singleData={modal.contact} toast={props.toast} /> :
                <Button style={{ width: '80px', height: '30px' }} loading={tableData.loading} onClick={openNew} label="New" icon="pi pi-plus" type="button" className="p-button-sm p-button-rounded p-button-success"></Button>} */}
            <DataTable value={tableData.data} loading={tableData.loading}
                className="grey-teal-table"
                size="small"
                stripedRows
                showGridlines
                responsiveLayout="scroll"
                scrollHeight="70vh"
                header={header}
                rowClassName={(d: IHotelContact) => (d.id === modal.contact.id ? 'bg-orange-100' : 'bg-teal-50')}
            >
                <Column field="name" header="Name" sortable />
                <Column field="email" header="Email" />
                <Column field="phone" header="Phone" />
                <Column field="whatsApp" header="WhatsApp" />
                <Column field="isPrimary" header="IsPrimary" sortable body={statusBody} />
                <Column field="designation" header="Designation" />
                <Column body={actionBodyTemplate} />
            </DataTable>
            {/* Dialog for ContactForm */}
            <Dialog header={modal.contact.id ? 'Update Contact' : 'Add Contact'} visible={modal.open} style={{ width: '800px' }} modal onHide={onClose}>
                <ContactForm singleData={modal.contact} onSuccess={onContactAddOrUpdateSuccess} onClose={onClose} toast={props.toast} />
            </Dialog>
        </div>
    );
}
